import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, UserRole } from "../context/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: UserRole;
}

const ROLE_LEVEL: Record<UserRole, number> = {
  editor: 0,
  dev: 1,
  admin: 2,
  owner: 3
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "40vh",
        color: "var(--color-text-muted)",
        fontSize: "0.875rem"
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requiredRole && ROLE_LEVEL[user.role] < ROLE_LEVEL[requiredRole]) {
    return (
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "40vh",
        color: "var(--color-danger)",
        fontSize: "0.875rem"
      }}>
        Access denied. You need {requiredRole} permissions.
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
